import { css } from "lit";

export const styleInputMessage = css`
  .input-message-container {
    display: flex;
    justify-content: center;
    align-items: end;
    max-width: 100%;
    height: auto;
    min-height: 61px;
    max-height: 100px;
    box-sizing: border-box;
    background-color: white;
    position: relative; /* Necesario para posicionar el overlay */
  }
    .input-message-overlay {
    position: absolute;
    top: 1px; /* Distancia desde el top del container */
    left: 1px;
    width: calc(100% - 90px); /* Ajusta según espacio del botón */
    height: 4px; /* Tamaño del área blanca que ocultará texto */
    background-color: white;
    z-index: 2;
    pointer-events: none; /* Permite que el usuario siga escribiendo */
  }

  .input-message {
    flex-grow: 1; /* Ocupa todo el espacio restante */
    box-sizing: border-box;
    padding: 17px 24px 17px 22px;
    border: 0.5px solid var(--Gray-5, #E0E0E0);
    width: auto;
    color: black;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    outline: none;
    transition: border-color 0.3s, box-shadow 0.3s;
    resize: none;
    min-height: 61px;
    height: auto;
  }
    .input-message::-webkit-scrollbar {
    width: 4px; /* Ancho del scroll */
  }

  .input-message::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3); /* Color de la barra */
    border-radius: 3px; /* Bordes redondeados */
  }

  .input-message::-webkit-scrollbar-track {
    background: transparent; /* Fondo del scroll */
  }

  //para firefox
  .input-message {
    scrollbar-width: thin; /* Hace que el scroll sea más delgado */
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent; /* Color de la barra y el fondo */
    }
    
    .input-message:focus {
      border: 0.5px solid var(--Azul_chatbot, #1446ff); /* Cambia el borde */
      background-color: white; /* Cambia el fondo */
    }

  .button-send {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px;
    margin: 0px 18px 4px;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    max-width: 50px;
    max-height: 50px;
    flex-shrink: 0;
    background-color: var(--Azul_chatbot, #1446ff);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    user-select: none;
    border-bottom: 0.5px solid var(--Gray-5, #E0E0E0);
  }

  .icon-send {
    position: relative;
    left: 2px;
    width: 22px;
    height: 19px;
    max-width: 22px;
    max-height: 19px;
    user-select: none;
  }
`;
